<template>
    <hr class="border border-opacity-10 w-full h-0 border-white-foreground" />
</template>
